import React, {useContext} from 'react';
import {useParams} from "react-router-dom";
import OrganizationHistoryTemplate from "../../../../components/Templates/OrganizationHistoryTemplate";
import CheckboxCell from "../../../../components/Pages/TablePage/Table/Cells/CheckboxCell";
import TextCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {AuthContext} from "../../../../context/AuthContext";

function OrganizationList() {
    const {orgName, orgId} = useParams()
    const userId = useContext(AuthContext)?.token?.userId
    const accessResultCell = (props) => {
        return <CheckboxCell payed={props.cellContent}
                             updateUrl={`/api/v2/verificationCenters/${userId}/organizations/${orgId}/histories/${props.idArr[0]}/payed`}/>
    }
    tableModel.haveToShow[6].typeData['cell'] = accessResultCell

    return (
        <OrganizationHistoryTemplate
            addNewStudyConfig={{API: `/api/v2/verificationCenters/${userId}/organizations/${orgId}/histories`, show: true}}
            getOrgHistoryAPI={`/api/v2/verificationCenters/${userId}/organizations/${orgId}/histories?`}
            tableModel={tableModel}
            breadCrumbsItems={[
                {title: 'Контрагенты',},
                {title: "Организации", link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/OrganizationList`},
                {
                    title: orgName,
                    link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/allOrgList/orgHistory/${orgId}/${orgName}`,
                    actual: true
                },
            ]
            }
        />

    );
}

export default OrganizationList;

var tableModel =
    {
        haveToShow: [
            {
                id: 'organization_info', idArr: ['id', "org_id"], type: 'toPatients', typeData: {
                    show: 'name', onClick: () => {
                    }
                }
            },
            {id: 'document', type: 'uploadLists2', idArr: ['id'], typeData: {uploaded: 'uploaded'}},
            {
                id: 'date',
                type: 'wrapperCell',
                typeData: {
                    cell: props => <TextCell
                        text={props.cellContent}/>
                }
            },
            {id: 'patients_count'},
            {id: 'base'},
            {id: 'invite_count'},
            {id: 'payed', idArr: ['id'], typeData: {}, type: 'wrapperCell'},
            {id: 'id', type: 'emailSend2'},
        ],
        firstRow:
            [
                {title: 'Название', id: 'name'},
                {title: 'Загрузить списки', id: ''},
                {title: 'Год', id: 'createdAt'},
                {title: 'Исследований', id: 'research'},
                {title: 'Вид исследования', id: 'base'},
                {title: 'Вызов', id: ''},
                {title: 'Доступ к результату', id: ''},
                {title: 'Печать', id: ''}
            ],
    }
